import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-organisation-course',
  templateUrl: './organisation-course.component.html',
  styleUrls: ['./organisation-course.component.scss']
})
export class OrganisationCourseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
